<script>
import TgModal from "@/abc-dsk/components/Modal/TgModal.vue";
import { Size } from "@/abc-dsk/options";
import DsnSpellingRulesService, {
  getParagraph,
  wrapParagraphs
} from "@/common/api/dsn-spelling-rules.service";

export default {
  name: "DsnSpellingRuleModal",
  components: {
    TgModal
  },
  props: {
    paragraph: {
      type: String,
      default: undefined
    }
  },
  emits: ["close", "clickParagraph"],
  data() {
    return {
      Size,
      isFetching: false,
      rule: null
    };
  },
  computed: {
    isOpen() {
      return this.paragraph !== undefined;
    }
  },
  watch: {
    paragraph: {
      immediate: true,
      handler: function (newVal, prevVal) {
        if (newVal && newVal !== prevVal) {
          this.fetchRule(newVal);
        }
      }
    }
  },
  methods: {
    async fetchRule(paragraph) {
      this.isFetching = true;

      try {
        this.rule = await DsnSpellingRulesService.fetchRule(paragraph);
      } finally {
        this.isFetching = false;
      }
    },
    wrapParagraphs,
    onClickDelegate(ev) {
      const paragraph = getParagraph(ev.target);

      if (paragraph) {
        this.$emit("clickParagraph", paragraph);
      }
    }
  }
};
</script>

<template>
  <TgModal
    dialog-class="dsn-spelling-rule-modal"
    :size="Size.Lg"
    :is-open="isOpen"
    @close="$emit('close')"
  >
    <template #modal-header>
      <template v-if="isFetching"> {{ $t("general.loading") }} </template>
      <template v-else-if="rule"> {{ rule.title }} </template>
    </template>

    <!-- eslint-disable vue/no-v-html -->
    <div
      v-if="!isFetching && rule"
      class="article-content__html dsn-spelling-rule-modal__html"
      @click.stop.prevent="onClickDelegate($event)"
      v-html="wrapParagraphs(rule.html)"
    ></div>
    <!-- eslint-enable vue/no-v-html -->
  </TgModal>
</template>
